// Note: axios import removed - auth.js only handles JWT parsing, no API calls

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

function getCookieValue(k){var v=document.cookie.match('(^|;) ?'+k+'=([^;]*)(;|$)');return v?decodeURIComponent(v[2]):null}

function getStoredToken() {
  const cookieToken = getCookieValue("jwtToken");
  if (cookieToken && cookieToken !== "undefined") {
    return cookieToken;
  }
  const localToken = window.localStorage.getItem('jwtToken');
  if (localToken && localToken !== 'undefined') {
    return localToken;
  }
  return null;
}

function getUserAgent() {
  if (typeof navigator === 'undefined') {
    return '';
  }
  return navigator.userAgent || '';
}

class AuthService {
  isLogged() {
    return getStoredToken() !== null
  }

  logout() {
    console.log("deleting cookie")
    document.cookie = 'jwtToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    localStorage.clear()
    // window.location.href= '/login';
  }

  setToken(token) {
    if (!token) {
      return;
    }
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `jwtToken=${encodeURIComponent(token)}; Path=/; SameSite=Lax${secure}`;
    window.localStorage.setItem('jwtToken', token);
  }

  getToken() {
    return getStoredToken();
  }

  hasSession() {
    return this.isLogged();
  }

  isAutomatedAgent() {
    const userAgent = getUserAgent();
    return /(google-read-aloud|googleother|googlebot|adsbot-google|mediapartners-google|apis-google|headlesschrome|lighthouse|pagespeed|crawler|spider|bot)/i.test(userAgent);
  }

  shouldLimitAutomatedAgentRequests() {
    return this.isAutomatedAgent() && !this.hasSession();
  }

  getCurrentJwtPayload() {
    const token = getStoredToken();
    if (!token) {
      return null;
    }
    try {
      return parseJwt(token);
    } catch (error) {
      return null;
    }
  }

  getCurrentUser() {
    const payload = this.getCurrentJwtPayload();
    if (payload) {
      return payload.name;
    }
    return 'Bienvenido';

  }

  getCurrentUserEmail() {
    const payload = this.getCurrentJwtPayload();
    if (payload) {
      return payload.username;
    }
    return 'Bienvenido';

  }

  getCurrentUnit() {
    const payload = this.getCurrentJwtPayload();
    if (payload?.unit) {
      return payload.unit.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    }
    return '';

  }

  userRoleIncludes(roles) {
    const allowedRoles = [...roles, "superuser"];

    if (allowedRoles.includes(this.getCurrentUserRole())) {
      return true;
    }
    return false;

  }

  getCurrentUserRole() {
    const payload = this.getCurrentJwtPayload();
    if (payload) {
      return payload.role;
    }
    return '';

  }

  // Parse the role directly from a given JWT without reading storage.
  // Use this right after login / deep-link token exchange, when the token
  // is in hand but may not yet be reliably readable back from cookie/localStorage
  // (the authoritative source at that moment is the token itself, not storage).
  getRoleFromToken(token) {
    if (!token) {
      return '';
    }
    try {
      const payload = parseJwt(token);
      return payload?.role || '';
    } catch (error) {
      console.warn('AuthService.getRoleFromToken: failed to parse JWT', error);
      return '';
    }
  }

  getCurrentUserOrgKey() {
    const payload = this.getCurrentJwtPayload();
    if (payload?.org) {
      return payload.org;
    }
    return '';
  }

  getCurrentUserOrg() {
    const payload = this.getCurrentJwtPayload();
    if (payload?.org) {
      return payload.org.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    }
    return 'Inicie Sesion';

  }
}

export default new AuthService();